/**
 * Metrics Summary Table Component
 * Displays count/average totals for each metric (matches original AngularJS table)
 */

import { Table } from 'antd';
import { useAppSelector } from '../../../store/hooks';

interface MetricsSummaryTableProps {
  className?: string;
}

function MetricsSummaryTable({ className }: MetricsSummaryTableProps) {
  const { totalMetrics, allMetricsTotal, allAverageTotal } = useAppSelector(state => state.dashboard);

  // Create table columns dynamically based on metrics
  const columns = [
    {
      title: '',
      dataIndex: 'type',
      key: 'type',
      width: 100,
    },
    ...totalMetrics.map(metric => ({
      title: metric.label,
      dataIndex: metric.label,
      key: metric.label,
      align: 'center' as const,
      render: (value: string) => (
        <span className="dashboard-totals">{value}</span>
      ),
    })),
    {
      title: 'Total',
      dataIndex: 'total',
      key: 'total',
      align: 'center' as const,
      render: (value: string) => (
        <span className="dashboard-totals">{value}</span>
      ),
    },
  ];

  // Create single data row
  const dataSource = [
    {
      key: '1',
      type: 'Count / Avg',
      total: `${allMetricsTotal} / ${allAverageTotal}`,
      ...totalMetrics.reduce((acc, metric) => ({
        ...acc,
        [metric.label]: `${metric.total} / ${metric.average}`,
      }), {}),
    },
  ];

  // Don't render if no metrics
  if (totalMetrics.length === 0) {
    return null;
  }

  return (
    <div className={`filter metrics ${className || ''}`}>
      <Table
        columns={columns}
        dataSource={dataSource}
        pagination={false}
        size="small"
        bordered
        showHeader={true}
        style={{ marginBottom: '20px' }}
      />
    </div>
  );
}

export default MetricsSummaryTable;